// App.jsx
import React, { useState } from "react";
import Navbar from "../components/Navbar";
import LandingPage from "../components/LandingPage";
import Analytics from "../components/GoogleAnalytics";

const MainLandingPage = () => {
  
  return (
    <div>
      <Analytics />
      <Navbar />
      <LandingPage />
    </div>
  );
}
export default MainLandingPage;
